import React from 'react'
import $t from '../../../i18n'
import Card from '../../common/Card'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { getIsHmoMember } from '../../../utils/hmoUtils'

import './SubscriptionCard.css'

const SubscriptionCard = ({ paymentDetails }) => {
  const userDetails = useSelector(state => state.profile.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const planName = isHmoMember
    ? paymentDetails?.subscriptions?.zuora?.PlanName__c ??
      paymentDetails?.subscriptions?.zuora?.ratePlans?.[0]?.ratePlanName?.split(
        '('
      )?.[0]
    : paymentDetails?.subscriptions?.zuora?.ratePlans?.[0]?.ratePlanName

  if (!paymentDetails?.subscriptions?.zuora?.ratePlans?.[0]) return null

  return (
    <Card className='subscription-card'>
      <div className='section'>
        <div className='plan-name semi-bold'>{planName}</div>
        {isHmoMember && (
          <div className='plan-decription'>
            {paymentDetails?.subscriptions?.zuora?.ratePlans?.[0]?.ratePlanName
              ?.split('(')?.[1]
              ?.replace(')', '')}
          </div>
        )}
        {!isHmoMember && (
          <div className='renewal-description plan-decription'>
            {!paymentDetails?.subscriptions?.internal?.expire_date &&
              $t('pages.paymentDetails.planRenew', {
                date: dayjs(
                  paymentDetails?.subscriptions?.zuora?.subscriptionEndDate
                ).format('MMMM D, YYYY')
              })}
            {!!paymentDetails?.subscriptions?.internal?.expire_date &&
              $t('pages.paymentDetails.planCanceled', {
                date: dayjs(
                  paymentDetails?.subscriptions?.internal?.expire_date
                ).format('MMMM D, YYYY')
              })}
          </div>
        )}
      </div>
      <div className='section row'>
        <div className='section-field'>
          <div className='section-title'>
            {isHmoMember
              ? $t('pages.paymentDetails.monthlyPremium')
              : $t('pages.paymentDetails.monthlyPayment')}
          </div>
          <div className='section-value semi-bold'>
            $
            {(
              paymentDetails?.subscriptions?.zuora?.ratePlans?.[0]
                ?.ratePlanCharges[0]?.price ?? 0
            ).toFixed(2)}
          </div>
        </div>
        {isHmoMember && (
          <>
            <div className='section-field'>
              <div className='section-title'>
                {$t('pages.paymentDetails.lastPayment')}
              </div>
              <div className='section-value semi-bold'>
                {dayjs(paymentDetails?.accountSummary?.lastPaymentDate)
                  ?.local()
                  ?.format('MMM DD, YYYY')}
              </div>
            </div>
            <div className='section-field'>
              <div className='section-title'>
                {$t('pages.paymentDetails.nextPayment')}
              </div>
              <div className='section-value semi-bold'>
                {dayjs(paymentDetails?.accountSummary?.dueDate)
                  ?.local()
                  ?.format('MMM DD, YYYY')}
              </div>
            </div>
          </>
        )}
      </div>
    </Card>
  )
}

export default SubscriptionCard
